import { useSaasStore } from '@/stores/saas-store';
import { Award, BarChart2, Calendar, Clock, Lock, Trophy } from 'lucide-react';

export default function ViewPalmares() {
  const playerPlusEnabled = useSaasStore(s => s.playerPlusEnabled);
  return (
    <div className='demo-view-enter space-y-8'>
      {/* Stats row */}
      <div className='grid grid-cols-2 md:grid-cols-4 gap-4'>
        {[
          { v: '47', l: 'Concours joués', c: 'text-blue-600 dark:text-blue-400' },
          { v: '23', l: 'Podiums (Top 3)', c: 'text-amber-600 dark:text-amber-400' },
          { v: '8', l: 'Victoires', c: 'text-emerald-600 dark:text-emerald-400' },
          { v: '12', l: 'Partenaires', c: 'text-purple-600 dark:text-purple-400' },
        ].map(({ v, l, c }) => (
          <div
            key={l}
            className='bg-slate-50 border border-slate-200 dark:bg-slate-900 dark:border-slate-800 rounded-2xl p-5 text-center'
          >
            <p className={`text-2xl font-black ${c}`}>{v}</p>
            <p className='text-[11px] text-slate-500 mt-1'>{l}</p>
          </div>
        ))}
      </div>

      <div className='grid md:grid-cols-2 gap-6'>
        {/* Recent results */}
        <div>
          <p className='text-[10px] font-black text-slate-500 uppercase tracking-widest mb-4'>Derniers résultats</p>
          <div className='space-y-3'>
            {[
              {
                rank: '1er',
                emoji: '🥇',
                name: 'Grand Prix Lyon 2026',
                detail: 'sur 94 équipes · Juin 2026',
                border: 'border-amber-500/25 from-amber-500/10',
              },
              {
                rank: '2e',
                emoji: '🥈',
                name: 'National Pétanque Marseille',
                detail: 'sur 128 équipes · Mai 2026',
                border: 'border-slate-500/25 from-slate-500/10',
              },
              {
                rank: '3e',
                emoji: '🥉',
                name: 'Open Été — Bordeaux',
                detail: 'sur 56 équipes · Avr 2026',
                border: 'border-orange-600/25 from-orange-600/10',
              },
            ].map(({ rank, emoji, name, detail, border }) => (
              <div
                key={name}
                className={`bg-gradient-to-r ${border} to-transparent border rounded-2xl p-4 flex items-center gap-4`}
              >
                <span className='text-2xl leading-none'>{emoji}</span>
                <div className='flex-1 min-w-0'>
                  <p className='font-bold text-slate-900 dark:text-white text-sm truncate'>{name}</p>
                  <p className='text-xs text-slate-500 dark:text-slate-400 mt-0.5'>
                    {rank} · {detail}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Joueur Plus teaser */}
        <div>
          <p className='text-[10px] font-black text-slate-500 uppercase tracking-widest mb-4'>
            Fonctionnalités avancées
          </p>
          <div className='space-y-2 mb-4'>
            {[
              { icon: BarChart2, text: 'Stats avancées (par format, par saison, partenaires)' },
              { icon: Trophy, text: 'Historique complet (47 concours)' },
              { icon: Award, text: 'Top partenaires et résultats par duo' },
              { icon: Calendar, text: 'Prochaines inscriptions à venir' },
            ].map(({ icon: Icon, text }) => (
              <div
                key={text}
                className='bg-slate-50 border border-slate-200 dark:bg-slate-900/60 dark:border-slate-800 rounded-xl p-3 flex items-center gap-3'
              >
                <div className='w-7 h-7 bg-slate-200 border border-slate-300 dark:bg-slate-800 dark:border-slate-700 rounded-lg flex items-center justify-center shrink-0'>
                  <Icon className='w-3.5 h-3.5 text-slate-400 dark:text-slate-600' />
                </div>
                <span className='text-slate-500 dark:text-slate-600 text-xs flex-1'>{text}</span>
                <Lock className='w-3.5 h-3.5 text-slate-400 dark:text-slate-700 shrink-0' />
              </div>
            ))}
          </div>

          {/* Upsell */}
          <div className='bg-gradient-to-r from-blue-600/20 to-indigo-600/20 border border-blue-500/25 rounded-2xl p-4 flex items-center justify-between'>
            <div>
              <p className='font-bold text-slate-900 dark:text-white text-sm'>Joueur Plus</p>
              <p className='text-xs text-blue-600 dark:text-blue-300 mt-0.5'>
                {playerPlusEnabled ? 'Tout débloquer · Sans pub' : 'Bientôt disponible'}
              </p>
            </div>
            <div className='text-right'>
              {playerPlusEnabled ? (
                <p className='font-black text-slate-900 dark:text-white text-lg'>
                  2 €<span className='text-xs font-normal text-blue-600 dark:text-blue-300'>/mois</span>
                </p>
              ) : (
                <span className='inline-flex items-center gap-1 bg-amber-100 text-amber-700 text-xs font-bold px-2 py-1 rounded-full'>
                  <Clock className='w-3 h-3' />
                  Bientôt
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
